<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Registrar solicitud de empaques
            <router-link :to="{ name: 'SolicitudEmpaque', params: { config: config } }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  :value.sync="$v.date.$model"
                  :isValid="checkIfValid('date')"
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicación:</label>
                <v-select
                  v-model="ubicacion"
                  :options="ubicaciones"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona una ubicación"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CSelect
                  :value.sync="$v.nombreCultivo.$model"
                  :isValid="checkIfValid('nombreCultivo')"
                  label="Cultivo:"
                  placeholder="Cultivo..."
                  invalidFeedback="Campo requerido, debe seleccionar una opción"
                  :options="cultivos"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Solicitante:</label>
                <CInput
                  v-model="solicitante"
                  :horizontal="{ input: 'col-sm-12' }"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CSelect
                  :value.sync="$v.nombreProduccion.$model"
                  :isValid="checkIfValid('nombreProduccion')"
                  label="Producción:"
                  placeholder="Producción..."
                  invalidFeedback="Campo requerido, debe seleccionar una opción"
                  :options="['Convencional', 'Orgánico']"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CTextarea
                  :value.sync="comentarios"
                  :label="`Comentarios: `"
                  placeholder="Comentarios..."
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="()=>{fetching=false}"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>

            <hr class="my-4 line" />
            <CRow class="mb-3">
              <CCol lg="5" xl="5">
                <v-select
                  v-model="empaque"
                  :options="empaques.filter(ff=>ff.cultivo === nombreCultivo)"
                  :loading="isLoadingPage"
                  class="form-group"
                  placeholder="Empaque"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
              <CCol lg="5" xl="5">
                <CInput
                  :value.sync="$v.cantidad.$model"
                  :isValid="checkIfValid('cantidad')"
                  placeholder="Cantidad"
                  type="number"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
              <CCol xl="1">
                <CButton @click="addEmpaque()" class="float-right" color="success">Agregar</CButton>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12">
                <CDataTable
                  hover
                  sorter
                  bordered
                  small
                  fixed
                  :items="detalles"
                  :fields="fieldsSecondModal"
                >
                  <template #empaque_id="{item}">
                    <td class="py-2">{{getEmpaque(item.empaque_id)}}</td>
                  </template>
                  <template #cantidad="{item}">
                    <td class="py-2">{{item.cantidad}}</td>
                  </template>
                  <template #cancel="{ index}">
                    <td class="py-2">
                      <CButton color="danger" square size="sm" @click="deleteDetalle(index)">Borrar</CButton>
                    </td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Entrada' , params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>
            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton v-else @click="addEntrada()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Solicitud de empaques"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
      <CModal
        size="sm"
        title="Solicitud de empaques"
        :centered="true"
        color="success"
        :show.sync="successModal"
        >Guardado con éxito.
        <template #footer>
          <CButton @click="successModal = false"  color="success">Aceptar</CButton>
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

const fieldsSecondModal = [
  { key: "empaque_id", label: "Empaque", _style: "width:20%" },
  { key: "cantidad", _style: "width:20%" },

  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "NuevoEntrada",

  components: {
    vSelect
  },

  data() {
    return {
      detalles: [],
      config: this.$route.params.config,
      date: null,
      ubicacion: "",
      folio: "",
      ubicaciones: [],
      solicitante: "",
      empaque: "",
      empaques: [],
      nombreCultivo: "",
      nombreProduccion: "",
      configuracion:[],
      fieldsSecondModal,
      cantidad: null,
      warningModal: false,
      successModal: false,
      error: "",
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      comentarios: '',
      fetching: false,
      medias:[],
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    cantidad: {
      required,
      notNegative: (value) => value >= 0
    },
    empaque: {
      required
    },
    nombreCultivo: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    },
    nombreProduccion: {
      required,
    },
  },

  computed: {
    isValidProduccion() {
      return !this.$v.nombreProduccion.$invalid ;
    },
    isValidDate() {
      return !this.$v.date.$invalid;
    },
    isValidCultivo() {
      return !this.$v.nombreCultivo.$invalid ;
    },
    isValidCantidad() {
      return !this.$v.cantidad.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    cultivos() {
      return this.configuracion.map(cultivo => {
        return cultivo.nombre
      })
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    },
    nombreCultivo: function() {
      this.nombre = ''
      this.embalajeKey += 1
    },
  },

  created() {
    this.$store.dispatch('getNanoid');
    this.isLoadingPage = true;
    this.$store;

    const ubi = [
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [{field: "payload->suspendido", value: false, operator: "="}],
          wherein: [
            {
              field: "payload->pertenece_id",
              value: [this.ubicacionRaizValue]
            }
          ],
          orWhere:[
            {
              field: "id",
              operator: "=",
              value: this.ubicacionRaizValue
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }),
      this.$store.dispatch("customHTTP", {
        schema: "empaques",
      }),
      this.$store.dispatch('customHTTP', {
        schema: 'configuracion',
        filter: {
          where: [{field: 'payload->parametro', value: 'cultivos', operator: '='}]
        }
      }),
    ];

    Promise.all(ubi)
      .then(([ubicaciones, empaques, configuracion]) => {
        this.empaques = empaques.data.map(empaque => {
          return { value: empaque.id, label: empaque.payload.nombre, cultivo: empaque.payload.cultivo };
        })
        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this.configuracion = configuracion.data[0].payload.valor
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    getEmpaque(id){
      return this.empaques.find(f=>f.value===id)?.label||''
    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    addEmpaque() {
      this.validateEmpaque();

      if (this.empaque && this.cantidad) {
        // this.detalles.push(this.nombreEtapa);
        this.detalles.push({
          empaque_id: this.empaque.value,
          cantidad: Number(this.cantidad),
        });
        this.resetEmpaque();
      }
    },

    deleteDetalle(index) {
      if (index !== -1) {
        this.detalles.splice(index, 1);
      }
    },
    async addEntrada() {
      this.validateEntrada();
      this.fetching = true
      this.isLoading = true;
      await (new Promise((res,)=>{
        const iter = setInterval(()=>{
          if(!this.fetching){
            this.error = ""
            clearInterval(iter)
            res()
          }
          debugger
        },1000)
      }))
      this.isLoading = false;
      if(this.error){
        this.successModal = false;
        return
      }

      if (this.isValidDate&&this.isValidProduccion) {
        if (!this.ubicacion) {
          this.error = "El campo ubicación es obligatorio";
          this.warningModal = true;
          return;
        }

        this.isLoading = true;
        let newDate = moment(this.date, "YYYY-MM-DD HH:mm:ss");
        // console.log(this.date);
        // console.log(newDate.format("YYYY-MM-DD HH:mm:ss"));
        // let newDate = new Date(this.date);

        this.$store
          .dispatch("customDocumentoAddHTTP", {
            schema: "solicitudes_empaques",
            payload: {
              encabezado: {
                produccion: this.nombreProduccion,
                fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                ubicacion: this.ubicacion ? this.ubicacion.value : "",
                ubicacion_raiz_id: this.ubicacionRaiz
                  ? this.ubicacionRaizValue
                  : null,
                solicitante: this.solicitante,
                comentarios: this.comentarios || '',
                cultivo: this.nombreCultivo,
              },
              anexos: this.medias,
              detalles: this.detalles,
            }
          })
          .then(() => {
            // console.log(res.data);
            this.currentAlertCounter = 6;

            // this.$router.push({ name: "Entrada" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            this.isLoading = false;
            if (!this.warningModal) {
              this.successModal = true;
            }
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateEntrada() {
      this.$v.date.$touch();
      this.$v.nombreProduccion.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
    validateEmpaque() {
      // this.$v.producto.$touch();
      this.$v.cantidad.$touch();
      this.$v.empaque.$touch();
    },
    resetEmpaque() {
      this.cantidad = null;
      this.empaque = "";
      this.$v.cantidad.$reset();
      this.$v.empaque.$reset();
    },
    updateCombos() {
      this.isLoadingPage = true;
      this.$store;
      this.ubicacion = null
      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [{field: "payload->suspendido", value: false, operator: "="}],
            wherein: [
              {
                field: "payload->pertenece_id",
                value: [this.ubicacionRaizValue]
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];

      Promise.all(ubi)
        .then(([ubicaciones]) => {
          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
        })
        .finally(() => (this.isLoadingPage = false));
    }
  }
};
</script>


<style src="spinkit/spinkit.min.css"></style>
<style>
.vs__dropdown-toggle{
  height: 35px;
}
</style>
<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
